import type { ElementType } from 'react'
import React from 'react'
import { View } from 'react-native'

import AndroidIcon from './components/AndroidIcon.native'
import IOsIcon from './components/IOsIcon.native'
import type { OSIconsType, WebProps } from './types'
import { OSIcons } from './types'

const OS_ICON: Record<OSIconsType, ElementType> = {
  android: AndroidIcon,
  ios: IOsIcon,
}

const AppDownloadButtons = (props: WebProps): JSX.Element => {
  if (!props.platform) {
    return (
      <View className="relative flex flex-row flex-wrap p-4">
        <View className="pr-2">
          <IOsIcon onIconClick={props.onAppStoreClick} />
        </View>
        <View className="pl-2">
          <AndroidIcon onIconClick={props.onPlayStoreClick} />
        </View>
      </View>
    )
  }
  const OSIcon = OS_ICON[props.platform]

  return (
    <View className="relative flex flex-row flex-wrap p-4 ">
      <OSIcon
        onIconClick={
          props.platform === OSIcons.android ? props.onPlayStoreClick : props.onAppStoreClick
        }
      />
    </View>
  )
}

export default AppDownloadButtons
